module.exports = __webpack_public_path__ + "static/media/termsImg_3.ed95155a.jpg";